import moment from 'moment';
import {
  CommonColumnsType,
  DownloadConfigInfoType,
  DownloadParamsType,
} from '@op/pages/download/types';
import type { IBilibiliHashtagItem } from '@opm/pages/Hashtag/tabs/BilibiliTab/constants';

// ─────────────────────────────────────────────────────────
// Download Config
// ─────────────────────────────────────────────────────────
//
// 调用方传入：
//   data: IBilibiliHashtagItem[]  —— hook 全量 records
//
// Excel 布局：
//   Date | Hour | Rank | Hashtag | Hashtag En | Tag
//
export const MarketingHashtagBilibiliDownload: DownloadConfigInfoType = {
  columns: (): CommonColumnsType => [
    { key: 'date', header: 'Date' },
    { key: 'hour', header: 'Hour' },
    { key: 'rank', header: 'Rank' },
    { key: 'hashtag', header: 'Hashtag' },
    { key: 'hashtag_en', header: 'Hashtag En' },
    // { key: 'tag_icon', header: 'Tag' },
  ],

  dealWithDataFunc: ({ data }: DownloadParamsType) => {
    const records: IBilibiliHashtagItem[] = data || [];
    return [...records]
      .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
      .map((item) => {
        const m = moment(item.time);
        return {
          date: m.format('YYYY-MM-DD'),
          hour: `${String(m.hours()).padStart(2, '0')}:00`,
          rank: item.rank,
          hashtag: item.hashtag,
          hashtag_en: item.hashtag_en,
          trending_label: item.trending_label,
          tag_icon: item.tag_icon,
        };
      });
  },
};
